import { render, staticRenderFns } from "./TabPlanning.vue?vue&type=template&id=c8fd53d6"
import script from "./TabPlanning.vue?vue&type=script&lang=js"
export * from "./TabPlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports